import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import DateRangeComp from "../../common/DateRangeComp";
import Pagination from "../../common/Pagination";
import * as actions from "../redux/VipListAction";

export const VipReport = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { memberid } = useParams();

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const startOfYesterday = new Date(yesterday.setHours(0, 0, 0, 0));
  const endOfYesterday = new Date(yesterday.setHours(23, 59, 59, 999));
  const timeZone = "Asia/Kuala_Lumpur";

  const [swalProps, setSwalProps] = useState({});
  const [pagenum, setPagenum] = useState(0);
  const [fromDate, setFromDate] = useState(startOfYesterday);
  const [toDate, setToDate] = useState(endOfYesterday);

  const vipListState = useSelector(({ vipList }) => vipList, shallowEqual);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  useEffect(() => {
    fetchVipReport();
  }, []);

  const fetchVipReport = (page) => {
    setPagenum(page ?? 0);
    dispatch(
      actions.fetchVipReport({
        action: "membervipreport",
        memberid,
        fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
        todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
        pagenum: page ?? 0,
      })
    );
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-2 mb-4">
        <i
          className="bi bi-chevron-left fs-2 mb-1"
          onClick={() => window.history.back()}
        />
        <h2>{intl.formatMessage({ id: "vipReport" })}</h2>
      </div>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div className="d-flex align-items-center justify-content-between mb-4">
        <DateRangeComp
          initialRange={[
            { startDate: fromDate, endDate: toDate, key: "selection" },
          ]}
          onDateChange={handleDateChange}
        />
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => fetchVipReport()}
        >
          {intl.formatMessage({ id: "search" })}
        </button>
      </div>
      <div
        className="mb-4 rounded d-flex align-items-center justify-content-spacebetween py-2 gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow"
        style={{ border: "1px solid grey" }}
      >
        <table className="text-start table-report w-100">
          <tbody>
            <tr>
              <td className="col-3 ps-2 td-line">
                {intl.formatMessage({ id: "commission" })} :{" "}
                {vipListState.vipReport?.totalcommission}
              </td>
              <td className="col-3 ps-2">
                {intl.formatMessage({ id: "claimed" })} :{" "}
                {vipListState.vipReport?.totalclaimed}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        className="p-3 rounded"
        style={{ backgroundColor: "var(--table-background)" }}
      >
        <div className="table-responsive">
          <table className="custom-table">
            <thead>
              <tr>
                <th>{intl.formatMessage({ id: "no" })}</th>
                <th>{intl.formatMessage({ id: "date" })}</th>
                <th>{intl.formatMessage({ id: "message" })}</th>
                <th className="text-end">
                  {intl.formatMessage({ id: "beforeAmount" })}
                </th>
                <th className="text-end">
                  {intl.formatMessage({ id: "amount" })}
                </th>
                <th className="text-end">
                  {intl.formatMessage({ id: "afterAmount" })}
                </th>
              </tr>
            </thead>
            <tbody>
              {vipListState.vipReport ? (
                vipListState.vipReport.memberVipReports.length > 0 ? (
                  vipListState.vipReport?.memberVipReports.map(
                    (memberVipReport, index) => (
                      <tr key={index}>
                        <td>{pagenum * 10 + index + 1}</td>
                        <td>{memberVipReport.reportdate}</td>
                        <td>{memberVipReport.message}</td>
                        <td className="text-end">{memberVipReport.bfamount}</td>
                        <td className="text-end">{memberVipReport.amount}</td>
                        <td className="text-end">{memberVipReport.afamount}</td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          totalPages={parseInt(vipListState.vipReport?.totalpage ?? "0")}
          currentPage={pagenum}
          onPageChange={(pageNumber) => {
            fetchVipReport(pageNumber);
          }}
        />
      </div>
    </div>
  );
};
